import React, { useState } from 'react'
import "./navbar.scss"
import {HiMenuAlt4, HiX} from "react-icons/hi"
import {motion} from "framer-motion"; 


export default function NavBar() {
  const [toggle, setToggle] = useState<boolean>(false);


  return (
    <nav className='app__navbar'>
      <div className='app__navbar-logo'>
        {/* <img className='kayanlogo' loading='lazy' src="/assets/logo.png" alt="logo" /> */}
        <p className='kayanlogo ' style={{fontSize:'30px', fontWeight:'800'}}>KayanX</p>
        
      </div>
      <ul className='app__navbar-links'>
        {['home', 'about', 'contact', 'work','skills'].map((item, index) =>(
          <li className='app__flex p-text' key={`link-${item}`}>
            <div>
            </div>
              <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className='app__navbar-menu'>
        <HiMenuAlt4 onClick={() => setToggle(true)}/>

        {toggle && (
          <div
            // whileInView={{ x: [300, 0] }}
            // transition={{ duration: 0.85, ease: 'easeOut' }}
          >
            <HiX onClick={() => setToggle(false)} />
            <ul>
              {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a href={`#${item}`} onClick={() => setToggle(false)}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </nav>
  )
}
